import React from "react";
import "../styles/Sectors.css";

function Sectors({ language }) {
  const sectors = [
    {
      id: 1,
      icon: 'https://raw.github.com/Helmifalfie7/nexofortis/main/assets/logo/antenne-radio.png',
      titleEN: "Communications",
      titleFR: "Communications",
    },
    {
      id: 2,
      icon: 'https://raw.github.com/Helmifalfie7/nexofortis/main/assets/logo/energie.png',
      titleEN: "Energy",
      titleFR: "Énergie",
    },
    {
      id: 3,
      icon:'https://raw.github.com/Helmifalfie7/nexofortis/main/assets/logo/banque.png',
      titleEN: "Banking & Insurance",
      titleFR: "Banque et Assurance",
    },
    {
      id: 4,
      icon: 'https://raw.github.com/Helmifalfie7/nexofortis/main/assets/logo/boutique.png',
      titleEN: "Retail",
      titleFR: "Commerce",
    },
    {
      id: 5,
      icon: 'https://raw.github.com/Helmifalfie7/nexofortis/main/assets/logo/la-technologie.png',
      titleEN: "Technology",
      titleFR: "Technologie",
    },
    {
      id: 6,
      icon: 'https://raw.github.com/Helmifalfie7/nexofortis/main/assets/logo/hotel.png',
      titleEN: "Hospitality",
      titleFR: "Hôtellerie",
    },
  ];

  return (
    <section id="sectors" className="sectors-section">
      <div className="container">
        <h2 className="section-title">
          {language === "fr" ? "Secteurs que nous avons desservis" : "Sectors We’ve Serve"}
        </h2>

        <p className="section-subtitle">
          {language === "fr"
            ? "Nous avons mené à bien des projets d’intégration dans plusieurs secteurs clés. Notre expérience couvre les communications, l’énergie, la banque et l’assurance, le commerce, la technologie et l’hôtellerie. Cette expertise diversifiée nous permet de répondre aux exigences spécifiques du marché et de fournir des solutions MuleSoft et Workato sur mesure pour un large éventail de défis opérationnels et réglementaires."
            : "We have delivered successful integration projects across multiple key industries, including communications, energy, banking & insurance, retail, technology, and hospitality. This diverse sector expertise enables us to address unique market requirements and provide tailored MuleSoft and Workato solutions for a wide range of operational and regulatory challenges."}
        </p>

        <div className="sectors-grid">
          {sectors.map((sector) => (
            <div key={sector.id} className="sector-card">
              <div className="sector-icon-gradient">
                <img
                  src={sector.icon}
                  alt={language === "fr" ? sector.titleFR : sector.titleEN}
                />
              </div>
              <h3 className="sector-title">
                {language === "fr" ? sector.titleFR : sector.titleEN}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Sectors;
